import { render, staticRenderFns } from "./FundTypes.vue?vue&type=template&id=364bd99e"
import script from "./FundTypes.vue?vue&type=script&lang=js"
export * from "./FundTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports